import ExportHoverTooltip from './ExportHoverTooltip'

export default function ExportFieldLabel({ htmlFor, tooltip, children }) {
  const labelText = (
    <ExportHoverTooltip content={tooltip} className="dashboardExportLabelText">
      {children}
    </ExportHoverTooltip>
  )

  if (htmlFor) {
    return (
      <label className="dashboardExportLabel" htmlFor={htmlFor}>
        {labelText}
      </label>
    )
  }

  return <span className="dashboardExportLabel">{labelText}</span>
}
